var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoAxa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 39,
    viewBox: "0 0 43 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0148315V38.9957H42.59V0.0148315H0ZM31.0512 36.424C30.9156 35.5219 30.7932 35.0985 30.6181 34.5812L29.2753 30.3932H23.3091L22.2376 31.772L23.1999 34.6088C23.3901 35.2053 23.5935 35.6692 23.9457 36.424H20.5558L20.0003 34.6088L18.6443 36.424H15.9192L15.3354 34.6217L13.8985 36.424H11.3485H11.1715C11.2393 36.3706 11.2939 36.3172 11.3485 36.2656C12.0397 35.6692 12.4747 35.1261 12.8533 34.6346L14.5896 32.4071L13.9117 30.3932H7.95867L3.30701 36.424H0.418085C1.51603 35.4962 1.8004 35.2053 2.20718 34.6751L11.0209 23.2892C11.1433 23.1309 11.2506 22.9707 11.3467 22.7995C11.5086 22.5344 11.6593 22.2289 11.7403 21.8588H14.6009C14.6009 22.4811 14.6951 22.8271 14.8307 23.3039L16.8383 29.4543L17.8684 28.1289L16.2281 23.2377C16.1057 22.8805 15.9569 22.4166 15.6593 21.8588H19.1302C19.2243 22.4019 19.3204 22.84 19.4692 23.3168L20.1057 25.2387L21.5973 23.3039C21.9362 22.8529 22.3976 22.3504 22.601 21.8588H25.6387C25.0418 22.3227 24.6632 22.8124 24.296 23.2763L20.9325 27.6374L21.5163 29.4396L26.3299 23.2892C26.4523 23.1033 26.5879 22.945 26.7235 22.7719C26.9005 22.5068 27.0493 22.2289 27.1435 21.857H29.9778C30.0192 22.3467 30.087 22.7719 30.2226 23.2229L33.8705 34.596C34.0475 35.2053 34.168 35.5772 34.6294 36.4258H31.0512V36.424Z",
    fill: "#004A93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31659 28.5908H13.3844L12.149 24.9182L9.31659 28.5908Z",
    fill: "#004A93"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5867 31.6924L18.2364 33.7064L19.2816 32.368L18.5622 30.3928L17.5867 31.6924Z",
    fill: "#004A93"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7586 28.5908H28.6909L27.4573 24.9182L24.7586 28.5908Z",
    fill: "#004A93"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3094 21.115H25.8048L42.1025 0H39.6072L23.3094 21.115Z",
    fill: "#E73137"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAxa);
export default __webpack_public_path__ + "static/media/LogoAxa.d4738661.svg";
export { ForwardRef as ReactComponent };